import Vue from 'vue';

export const FACT_ADD = 'FACT_ADD';
export const DIMENSION_ADD = 'DIMENSION_ADD';
export const LINK_ADD = 'LINK_ADD';
export const ON_CONFIRM_DIALOG_CANCEL_CLICK = 'ON_CONFIRM_DIALOG_CANCEL_CLICK';
export const ON_CONFIRM_DIALOG_OK_CLICK = 'ON_CONFIRM_DIALOG_OK_CLICK';
export const ON_CONFIRM_DIALOG_OPEN = 'ON_CONFIRM_DIALOG_OPEN';
export const DIMENSION_LINK_ADD = 'DIMENSION_LINK_ADD';
export const SHOW_ATTRIBUTES = 'SHOW_ATTRIBUTES';
export const SHOW_MEASURES = 'SHOW_MEASURES';
export const SHOW_MINOR = 'SHOW_MINOR';
export const ON_ASSIGN_USERS_TO_FIELD_PERMISSION = 'ON_ASSIGN_USERS_TO_FIELD_PERMISSION';
export const ON_ASSIGN_GROUPS_TO_FIELD_PERMISSION = 'ON_ASSIGN_GROUPS_TO_FIELD_PERMISSION';
export const ON_MONITORING_FILE_LOGS_GET = 'ON_MONITORING_FILE_LOGS_GET';
const eventBus = new Vue();

export default eventBus;